import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=0ce7e1df&scoped=true"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=0ce7e1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce7e1df",
  null
  
)

export default component.exports